import React from 'react';
import { StructuredText } from 'react-datocms';
import {
  renderStructuredBlock,
  transformContentBody,
} from './StructuredContentBlock';

/**
 * More Information tab: structured content (videos, images, audio, etc.).
 */
export function MoreInfoTab({ content }) {
  if (!content?.length) return null;

  return (
    <>
      {content.map(({ body }, index) => {
        if (!body?.value) return null;

        const transformedContent = transformContentBody(body);

        return (
          <div key={index} style={{ margin: '2em 0' }}>
            <StructuredText
              data={transformedContent}
              renderBlock={({ record }) => renderStructuredBlock({ record })}
            />
          </div>
        );
      })}
    </>
  );
}
